<template>
  <RouterView />
</template>

<script>
export default {
  name: "App",
  data() {
    return {};
  },
  computed: {},
  components: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/jquery-ui.min.css";
@import "@/assets/css/bootstrap.css";
@import "@/assets/css/bootstrap-theme.css";
@import "@/assets/css/bootstrap-biz.css";
@import "@/assets/css/add-biz.css";
</style>

